import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { MapContainer, Marker, TileLayer, useMap, useMapEvents } from 'react-leaflet';

// Fix Leaflet marker icon issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

const MapMover = ({ center }) => {
  const map = useMap();
  map.setView(center, 16);
  return null;
};

const Step5 = ({ formData, setFormData }) => {
  const [mapCenter, setMapCenter] = useState([10.3157, 123.8854]); // Default Cebu
  const [markerPos, setMarkerPos] = useState(null);
  const [searchAddress, setSearchAddress] = useState(formData.billAddress || '');

  const reverseGeocode = async (lat, lng) => {
    try {
      const res = await fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`);
      const data = await res.json();
      return data.display_name || `Lat: ${lat}, Lng: ${lng}`;
    } catch (err) {
      console.error(err);
      return `Lat: ${lat}, Lng: ${lng}`;
    }
  };

  const handleSearch = async () => {
    const query = searchAddress.trim();
    if (!query) return;

    try {
      const res = await fetch(`https://photon.komoot.io/api/?q=${encodeURIComponent(query)}`);
      const data = await res.json();

      if (data.features?.length) {
        const [lng, lat] = data.features[0].geometry.coordinates;
        const address = data.features[0].properties.label || query;
        const center = [lat, lng];

        setMapCenter(center);
        setMarkerPos(center);
        setSearchAddress(address);
        setFormData((prev) => ({
          ...prev,
          billAddress: address,
          billLat: lat,
          billLng: lng,
        }));
      } else {
        alert('Address not found.');
      }
    } catch (err) {
      console.error(err);
      alert('Search failed. Please try again.');
    }
  };

  const handleMarkerDragEnd = async (e) => {
    const lat = e.target.getLatLng().lat;
    const lng = e.target.getLatLng().lng;
    const address = await reverseGeocode(lat, lng);
    setSearchAddress(address);
    setMarkerPos([lat, lng]);
    setFormData((prev) => ({
      ...prev,
      billAddress: address,
      billLat: lat,
      billLng: lng,
    }));
  };

  const LocationMarker = () => {
    useMapEvents({
      click: async (e) => {
        const lat = e.latlng.lat;
        const lng = e.latlng.lng;
        const address = await reverseGeocode(lat, lng);
        setMapCenter([lat, lng]);
        setMarkerPos([lat, lng]);
        setSearchAddress(address);
        setFormData((prev) => ({
          ...prev,
          billAddress: address,
          billLat: lat,
          billLng: lng,
        }));
      },
    });

    return markerPos ? (
      <Marker
        position={markerPos}
        draggable={true}
        eventHandlers={{ dragend: handleMarkerDragEnd }}
      />
    ) : null;
  };

  return (
    <div className="card p-4">
      <h5 className="card-title mb-3">Step 5: Billing Info</h5>
      <Form onSubmit={(e) => { e.preventDefault(); handleSearch(); }}>
        <Row>
          
          <Col md={12}>
            <h6>Bill Delivery Option</h6>
            <Form.Group className="mb-3">
              <Form.Label>Bill Delivery *</Form.Label>
              <Form.Select
                value={formData.billAddress || ''}
                onChange={(e) => setFormData({ ...formData, billAddress: e.target.value })}
              >
                <option value="">Select Delivery Option</option>
                <option value="SPOT BILLING">SPOT BILLING</option>
                <option value="EMAIL">EMAIL</option>
                <option value="SMS">SMS</option>
                <option value="POSTAL">POSTAL</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={12}>
            <h6>Billing Address</h6>
            <Form.Group className="mb-3">
              <Form.Label>Search or click map *</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter address and press Enter"
                value={searchAddress}
                onChange={(e) => setSearchAddress(e.target.value)}
              />
            </Form.Group>

            <div style={{ height: '300px', marginBottom: '1rem' }}>
              <MapContainer center={mapCenter} zoom={16} style={{ height: '100%', width: '100%' }}>
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution="&copy; OpenStreetMap contributors"
                />
                <MapMover center={mapCenter} />
                <LocationMarker />
              </MapContainer>
            </div>
          </Col>

        </Row>
      </Form>
    </div>
  );
};

export default Step5;
